/**
 * Vardiya QR payload sözleşmesi (mobil + web ortak).
 *
 * Format (kendini tanımlayan, versiyonlu): `GTS.ATT.v1:{companyId}:{branchId}:{in|out}`
 * - direction boş → "Tek QR" (yönsüz): single vardiyalar için backend saat penceresiyle
 *   otomatik giriş/çıkış belirler.
 * - direction "in"/"out" → dual vardiyalar için yönlü QR (yön daima QR'dan gelir).
 *
 * CompanyId her zaman payload'a gömülür → şube QR'ı artık "başka şirkete ait" hatası vermez.
 * Mobil karşılığı: `shift_attendance_service.dart` / `shift_qr_modal.dart`.
 */

export type QrDirection = 'in' | 'out' | null;

export function buildShiftQrPayload(
  companyId: string,
  opts: { branchId?: string | null; direction?: QrDirection } = {}
): string {
  const branch = opts.branchId ?? '';
  const dir = opts.direction ?? '';
  return `GTS.ATT.v1:${companyId}:${branch}:${dir}`;
}
